import * as React from 'react'
import cx from 'classnames'
import styles from './Chip.sass'
import Icon from 'components/Icon'

interface ChipProps {
  children?: React.ReactNode
  onRemoveClick?: () => unknown
  icon?: React.ReactNode
  variant?: 'default' | 'filter'
  onClick?: () => void
  ['data-test']?: string
}

export default React.forwardRef(function Chip(
  {
    children,
    onRemoveClick,
    icon,
    onClick,
    variant = 'default',
    'data-test': dataTest,
  }: ChipProps,
  ref: React.Ref<any>,
) {
  // All variants but "filter" has the remove button be embedded within the main
  // area of the chip.
  const embedded = variant !== 'filter'
  const removeBtnRef = React.useRef<any>()
  const click = React.useCallback(
    (e: React.MouseEvent) => {
      // Ignore clicks on the remove button.
      if (e.target === removeBtnRef.current) {
        return
      }

      onClick?.()
    },
    [onClick],
  )
  return (
    <div
      className={cx(styles.root)}
      data-test={dataTest}
      ref={ref}
      onClick={click}
    >
      <div
        className={cx(
          styles.main,
          onClick && styles.clickable,
          embedded && styles.embedded,
        )}
      >
        {icon && <div className={styles.icon}>{icon}</div>}
        <div className={styles.content}>
          <span className={styles.text}>{children}</span>
        </div>
        {onRemoveClick && embedded && (
          <div className={styles.embeddedActions}>
            <a
              ref={removeBtnRef}
              className={styles.embeddedRemove}
              onClick={onRemoveClick}
              data-test={`${dataTest}-remove`}
            >
              <Icon size={16} name="close" />
            </a>
          </div>
        )}
      </div>
      {onRemoveClick && !embedded && (
        <a
          ref={removeBtnRef}
          className={styles.separatedRemove}
          onClick={onRemoveClick}
          data-test={`${dataTest}-remove`}
        >
          <Icon size={16} name="close" />
        </a>
      )}
    </div>
  )
})
